export function contactStateKey(contact) {
    if (contact.hasPendingProposals()) return 'pendingProposals';
    if (contact.hasDrafts()) return 'drafts';
    return 'default';
}
export const eligibilityTooltipsTextsPath = 'client.contactsDashboardOld.eligibilityTooltips';
export function eligibilityTooltipProps(eligibility, texts) {
    if (eligibility.type === 'eligible') return undefined;
    return {
        title: texts[eligibility.notEligible.reason].delete(),
        placement: 'bottom'
    };
}
export const contactBiData = (contact)=>({
        contact: {
            firstName: contact.firstName(),
            lastName: contact.lastName(),
            email: contact.email()
        }
    });
